import { render, staticRenderFns } from "./ThePDPModal.vue?vue&type=template&id=2901a3d5&"
import script from "./ThePDPModal.vue?vue&type=script&lang=js&"
export * from "./ThePDPModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../sfra-webpack-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/lucia/proyectos/byl_salesforce/sfra-webpack-builder/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2901a3d5')) {
      api.createRecord('2901a3d5', component.options)
    } else {
      api.reload('2901a3d5', component.options)
    }
    module.hot.accept("./ThePDPModal.vue?vue&type=template&id=2901a3d5&", function () {
      api.rerender('2901a3d5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app_byl_core/cartridges/app_byl_core/cartridge/client/default/js/vue/components/ThePDPModal.vue"
export default component.exports